<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-rocket-launch', fontSet: 'fad'}"
	[headerText]="T.RECORDER_INITIALIZE_INIT | translate"
	[matDialogData]="data"
	[rect]="rect"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<div class="initializingTasksContainer">
			@for (initTask of data?.tasks; track initTask) {
				<div [class.finished]="initTask.success !== undefined" class="initializationTask">
					<div class="initDescription">
						{{ initTask.name }}
					</div>
					<div class="initValue">
						<mat-divider [vertical]="true" class="initValueDivider" />
						<i class="fad fa-spinner-third fa-spin loadingIcon"></i>
						<i
							[class.accent]="initTask.success === true"
							[class.fa-check]="initTask.success === true"
							[class.fa-times]="initTask.success === false"
							[class.warn]="initTask.success === false"
							[matTooltipClass]="initTask.success === true ? 'accent' : 'warn'"
							[matTooltip]="
								initTask.success === true
									? (T.JOIN_TRAINING_DIALOG_TASK_FINISHED_SUCCESS | translate)
									: (T.JOIN_TRAINING_DIALOG_ERROR_EXECUTING_TASK | translate)
							"
							class="fad finishedIcon"
						>
						</i>
					</div>
				</div>
			}
		</div>
	</ng-container>

	@if (failed) {
		<ng-container actions>
			<sim-button
				(onClick)="toDashboard()"
				[icon]="{fontSet: 'fad', fontIcon: 'fa-home'}"
				color="accent"
				style="margin-right: 15px"
				[label]="T.RECORDING_INITIALIZATION_DIALOG_BUTTON_DASHBOARD"
			/>
			<sim-button
				(onClick)="reload()"
				[icon]="{fontSet: 'fad', fontIcon: 'fa-redo'}"
				color="accent"
				[label]="T.RECORDING_INITIALIZATION_DIALOG_TRY_AGAIN"
			/>
		</ng-container>
	}
</sim-basic-material-dialog>
